<template>
    <div v-if="hasErrors" class="text-sm shadow-sm rounded flex items-stretch justify-start">
        <div class="px-3 py-2 bg-glm-red text-red-100 flex items-center justify-center rounded-l">
            <font-awesome-icon
                :icon="['fad', 'siren-on']"
                size="lg"
                class="fa-fw"
            ></font-awesome-icon>
        </div>

        <div class="px-3 py-2 bg-red-100 text-glm-red flex-1 rounded-r">
            <div class="font-medium">Whoops! Something went wrong.</div>

            <ul class="mt-2 list-disc list-inside text-sm">
                <li v-for="(error, key) in errors" :key="key">{{ error }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        errors () {
            return this.$page.props.errors
        },

        hasErrors () {
            return Object.keys(this.errors).length > 0
        },
    },
}
</script>
